module.exports = __webpack_public_path__ + "img/kpp.3f30e037.jpg";